import React from 'react'
import { Horizontal, Vertical, Texto, addCommasToNumber } from '@gravitate-js/excalibrr'
import { useDirectiveContext } from '@components/Reports/DispatchDirective/DirectiveContext'
export const IntradayTodayRow = ({ directive }) => {
  const { viewingPlanned } = useDirectiveContext()
  const total = viewingPlanned
    ? directive.loaded + directive.planned + directive.scheduled + directive.carrier
    : directive.loaded + directive.scheduled + directive.carrier

  return (
    <Horizontal height={25}>
      <Vertical flex={1}>
        <Horizontal>
          <Vertical flex={1}>
            <Texto weight={600} align='right' appearance={directive.loaded !== 0 ? 'primary' : 'medium'} category='h6'>
              {addCommasToNumber(directive.loaded)}
            </Texto>
          </Vertical>
          <Vertical flex={1}>
            <Texto
              weight={600}
              align='right'
              appearance={directive.scheduled !== 0 ? 'secondary' : 'medium'}
              category='h6'
            >
              {addCommasToNumber(directive.scheduled, 0)}
            </Texto>
          </Vertical>
          {viewingPlanned && (
            <Vertical className='pr-4' flex={1}>
              <Texto weight={600} align='right' appearance='medium' category='h6'>
                {addCommasToNumber(directive.planned, 0)}
              </Texto>
            </Vertical>
          )}

          <Vertical className='pr-4' flex={1}>
            <Texto weight='bold' appearance={total ? 'default' : 'medium'} align='right' category='h6'>
              {addCommasToNumber(total, 0) || 'N/A'}
            </Texto>
          </Vertical>
          <Vertical className='pr-4' flex={1}>
            <Texto
              weight={directive.directive_min ? 600 : 500}
              appearance={directive.directive_min ? 'default' : 'hint'}
              align='right'
              category='h5'
            >
              {directive?.directive_min || directive?.directive_min === 0
                ? addCommasToNumber(directive?.directive_min, 0)
                : 'Not Set'}
            </Texto>
          </Vertical>

          <Vertical className='pr-4' flex={1}>
            <Texto
              weight={directive.directive_max ? 600 : 500}
              appearance={directive.directive_max ? 'default' : 'medium'}
              align='right'
              category='h5'
            >
              {directive?.directive_max || directive?.directive_max === 0
                ? addCommasToNumber(directive?.directive_max, 0)
                : 'Not Set'}
            </Texto>
          </Vertical>
        </Horizontal>
      </Vertical>
    </Horizontal>
  )
}
